export default __webpack_public_path__ + "static/media/AddAdmin.345a7fa6.svg";